import React from "react";
import Newsletter_36 from "../component/Newsletter_36";

function Newsletter_36Container() {
  return <Newsletter_36 />;
}

export default Newsletter_36Container;
